<template>
  <section>
    <div class="box-img">
      <img :src="imgUrl">
    </div>

    <div class="box-content">
      <div class="box"></div>
      <div class="box-text">
        <p>{{ published }}</p>
        <h2>{{ name }}</h2>
        <span v-html="dec"></span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    name: String,
    published: String,
    dec: String,
    imgUrl: String
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

section {
  transition: 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);

  .box-img {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    height: 300px;
    background-color: $active;

    img {
      width: calc(100% - 5px);
      height: 100%;
      transition: 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    }
  }

  .box-content {
    display: flex;
    justify-content: flex-start;
    margin-top: 12px;

    .box {
      margin-top: 38px;
      width: 15px;
      height: 15px;
      background-color: $active;
    }

    .box-text {
      margin-left: 12px;
      width: 100%;

      p {
        margin-left: -26px;
        font-size: 1.25rem;
        color: $active;
      }

      h2 {
        margin: 6px 0 6px 0;
        line-height: 1;
        font-size: 1.5rem;
        color: black;
      }

      span {
        line-height: 1.1;
        font-size: 1.25rem;
      }
    }
  }
}

section:hover {
  filter: opacity(60%);

  img {
    width: calc(100% - 15px);
  }
}
</style>
